/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Deutsch_Lernen18Inputs */

const en__field_enum_icsrm_deutsch_lernen18 = /** @type {(inputs: _Field_Enum_Icsrm_Deutsch_Lernen18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`improve your proficiency in german`)
};

const de__field_enum_icsrm_deutsch_lernen18 = /** @type {(inputs: _Field_Enum_Icsrm_Deutsch_Lernen18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch lernen/ verbessern`)
};

/**
* | output |
* | --- |
* | "improve your proficiency in german" |
*
* @param {_Field_Enum_Icsrm_Deutsch_Lernen18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_deutsch_lernen18 = /** @type {((inputs?: _Field_Enum_Icsrm_Deutsch_Lernen18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Deutsch_Lernen18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_deutsch_lernen18(inputs)
	return de__field_enum_icsrm_deutsch_lernen18(inputs)
});
export { _field_enum_icsrm_deutsch_lernen18 as "_field_enum_ICSRM_DEUTSCH_LERNEN" }